import React from 'react';
import ReactDOM from 'react-dom';
import Game from './components/Game';
import './index.css';

ReactDOM.render(
  <Game />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js